export default "__VITE_ASSET__5fc7d3b1__"